import React from "react";
import { ifUnstableFeatureEnabled } from "./hoc/ifUnstableFeatureEnabled";
import { Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { unstableFeaturesStatus } from "../../selectors/unstable-features";

const BarModal = connect(
  (state, ownProps) => ({
    unstableFeaturesStatus: unstableFeaturesStatus(state),
  }),
  (dispatch, ownProps) => ({}),
)(
  class extends React.Component {
    constructor(props, context) {
      super(props, context);

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);

      this.state = {
        show: false,
      };
    }

    handleClose() {
      this.setState({ show: false });
    }

    handleShow() {
      this.setState({ show: true });
    }

    render() {
      return (
        <span>
          <div
            style={{
              position: "fixed",
              top: "10px",
              left: "50%",
              zIndex: 1031,
            }}
          >
            <Button
              id="qa-unstable-features-status-modal-launcher"
              bsSize="small"
              style={{ backgroundColor: "transparent", color: "#FF0000" }}
              onClick={this.handleShow}
            >
              Unstable Features
            </Button>

            <Modal
              id="qa-unstable-features-status-modal"
              show={this.state.show}
              onHide={this.handleClose}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <code>/api/unstable-features-status</code> response:
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <pre>
                  {JSON.stringify(
                    this.props.unstableFeaturesStatus,
                    undefined,
                    2,
                  )}
                </pre>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  id="close-qa-unstable-features-status-modal"
                  onClick={this.handleClose}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </span>
      );
    }
  },
);

export const QaUnstableFeaturesStatusModal = ifUnstableFeatureEnabled({
  featureName: "qa-unstable-features-status-modal",
  Enabled: BarModal,
  Disabled: null,
});



// WEBPACK FOOTER //
// ./src/sc/ui/components/QaUnstableFeaturesStatusModal.js